<template>
  <div class="section-care-plan-card care-plan-card-wrapper">
    <div v-if="isWebOnlyDiscount" class="is-web-only">WEB ONLY</div>
    <div v-else-if="showTag" class="is-best-value">BEST VALUE</div>
    <div v-else></div>
    <div class="plan-card-container">
      <div class="block-plan-name-container">
        {{ planName }}
      </div>
      <div class="divider"></div>
      <div class="block-plan-price">
        <div v-if="planPrice === 0">
          {{ $t('care.planPrice.free') }}
        </div>
        <div v-else class="non-free">
          <span :class="{'origin-price': hasDiscount}">
            USD {{ planPrice }} /{{ priceUnit }}
          </span>
          <span v-if="hasDiscount" class="discount-price">
            USD {{ planSpecialPrice.price }} /{{ priceUnit }}
          </span>
          <span v-if="hasDiscount" class="limited-offer-notice">
            Limited Offer: now ~ 2024.01.31
          </span>
        </div>
      </div>
      <div class="block-plan-detail-list">
        <div class="plan-detail-item">
          <div class="img-wrapper">
            <div
              class="img-icon"
              :class="{'inactive': !isFeatureActiveMap.continuousVideo}">
              <!-- icon image -->
            </div>
          </div>
          <div class="text-desc"
              :class="{'inactive': !isFeatureActiveMap.continuousVideo}">
            <div v-if="!isFeatureActiveMap.continuousVideo">
              {{ $t('care.featureName.continuousVideo') }}
            </div>
            <div v-else>
              {{ $t('care.planDetail.continuousVideo', { number: continuousVideoDay }) }}
            </div>
          </div>
        </div>
        <div class="plan-detail-item">
          <div class="img-wrapper">
            <div class="img-icon">
              <!-- icon image -->
            </div>
          </div>
          <div class="text-desc">
            {{ $t('care.planDetail.eventVideo', { number: eventVideoDay }) }}
          </div>
        </div>
        <div class="plan-detail-item">
          <div class="img-wrapper">
            <div
              class="img-icon"
              :class="{'inactive': !isFeatureActiveMap.breathing}">
              <!-- icon image -->
            </div>
          </div>
          <div class="text-desc" :class="{'inactive': !isFeatureActiveMap.breathing}">
            {{ $t('care.planDetail.breathing') }}
          </div>
        </div>
        <div class="plan-detail-item">
          <div class="img-wrapper">
            <div
              class="img-icon"
              :class="{'inactive': !isFeatureActiveMap.continuousVideo}">
              <!-- icon image -->
            </div>
          </div>
          <div class="text-desc"
              :class="{'inactive': !isFeatureActiveMap.continuousVideo}">
            <div v-if="!isFeatureActiveMap.continuousVideo">
              {{ $t('care.featureName.sleeplogHistory') }}
            </div>
            <div v-else>
              {{ $t('care.planDetail.sleeplogHistory', { number: sleeplogHistoryDay }) }}
            </div>
          </div>
        </div>
        <div class="plan-detail-item">
          <div class="img-wrapper">
            <div
              class="img-icon"
              :class="{'inactive': !isFeatureActiveMap.continuousVideo}">
              <!-- icon image -->
            </div>
          </div>
          <div class="text-desc"
              :class="{'inactive': !isFeatureActiveMap.continuousVideo}">
            <div v-if="!isFeatureActiveMap.continuousVideo">
              {{ $t('care.featureName.sleepPlayback') }}
            </div>
            <div v-else>
              {{ $t('care.planDetail.sleepPlayback', { number: continuousVideoDay }) }}
            </div>
          </div>
        </div>
        <div class="plan-detail-item">
          <div class="img-wrapper">
            <div
              class="img-icon"
              :class="{'inactive': !isFeatureActiveMap.snapCute}">
              <!-- icon image -->
            </div>
          </div>
          <div class="text-desc"
              :class="{'inactive': !isFeatureActiveMap.snapCute}">
            <div v-if="!isFeatureActiveMap.snapCute">
              {{ $t('care.featureName.snapCute') }}
            </div>
            <div v-else-if="snapCuteCnt !== 'Unlimited'">
              {{ $t('care.planDetail.snapCute', { number: snapCuteCnt }) }}
            </div>
            <div v-else>
              {{ $t('care.planDetail.snapCuteUnlimit') }}
            </div>
          </div>
        </div>
        <div class="plan-detail-item">
          <div class="img-wrapper">
            <div class="img-icon">
              <!-- icon image -->
            </div>
          </div>
          <div v-if="cameraShareCnt !== 'Unlimited'" class="text-desc">
            {{ $t('care.planDetail.cameraShare', { number: cameraShareCnt }) }}
          </div>
          <div v-else class="text-desc">
            {{ $t('care.planDetail.cameraShareUnlimit', { number: cameraShareCnt }) }}
          </div>
        </div>
        <div class="plan-detail-item">
          <div class="img-wrapper">
            <div class="img-icon">
              <!-- icon image -->
            </div>
          </div>
          <div class="text-desc">
            {{ $t('care.planDetail.cryDetector') }}
          </div>
        </div>
        <div class="plan-detail-item">
          <div class="img-wrapper">
            <div class="img-icon">
              <!-- icon image -->
            </div>
          </div>
          <div class="text-desc">
            {{ $t('care.planDetail.noiseDetector') }}
          </div>
        </div>
        <div class="plan-detail-item">
          <div class="img-wrapper">
            <div class="img-icon">
              <!-- icon image -->
            </div>
          </div>
          <div class="text-desc">
            {{ $t('care.planDetail.crossDetector') }}
          </div>
        </div>
        <div class="plan-detail-item">
          <div class="img-wrapper">
            <div class="img-icon">
              <!-- icon image -->
            </div>
          </div>
          <div class="text-desc">
            {{ $t('care.planDetail.smartDiary') }}
          </div>
        </div>
        <div class="plan-detail-item">
          <div class="img-wrapper">
            <div class="img-icon">
              <!-- icon image -->
            </div>
          </div>
          <div class="text-desc">
            {{ $t('care.planDetail.familyDiary') }}
          </div>
        </div>
        <div class="plan-detail-item">
          <div class="img-wrapper">
            <div class="img-icon">
              <!-- icon image -->
            </div>
          </div>
          <div class="text-desc">
            {{ $t('care.planDetail.push2talk') }}
          </div>
        </div>
        <div class="plan-detail-item">
          <div class="img-wrapper">
            <div class="img-icon">
              <!-- icon image -->
            </div>
          </div>
          <div class="text-desc">
            {{ $t('care.planDetail.lullaby') }}
          </div>
        </div>
        <div class="plan-detail-item">
          <div class="img-wrapper">
            <div class="img-icon">
              <!-- icon image -->
            </div>
          </div>
          <div class="text-desc">
            {{ $t('care.planDetail.cameraPhoto') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getCarePriceDiscountStatus } from '../../services/marketing';
import planEnum from '../../enums/planEnum';

export default {
  name: 'care-plan-card',
  props: {
    isAnnualActive: {
      type: Boolean,
      required: true,
    },
    isFeatureActiveMap: {
      type: Object,
      required: true,
    },
    planKeyName: {
      type: String,
      required: true,
    },
    planPrice: {
      type: Number,
      required: true,
    },
    planSpecialPrice: {
      type: Object,
      default() {
        return {
          isActive: false,
          price: 0,
          showWebOnly: false,
        };
      },
    },
    eventVideoDay: {
      type: Number,
      required: true,
    },
    continuousVideoDay: {
      type: Number,
      required: true,
    },
    cameraShareCnt: {
      type: [Number, String],
      required: false,
    },
    sleeplogHistoryDay: {
      type: [Number, String],
      required: false,
    },
    snapCuteCnt: {
      type: [Number, String],
      required: false,
    },
    showTag: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    isShowCVRIcon() {
      return [planEnum.PREMIUM_PRO, planEnum.ELITE_PRO].includes(this.planKeyName);
    },
    hasDiscount() {
      return getCarePriceDiscountStatus() && this.planSpecialPrice.isActive;
    },
    isWebOnlyDiscount() {
      return getCarePriceDiscountStatus() && this.planSpecialPrice.showWebOnly;
    },
    priceUnit() {
      if (this.isAnnualActive) {
        return this.$t('care.planPrice.unitYr');
      }

      return this.$t('care.planPrice.unitMo');
    },
    planName() {
      switch (this.planKeyName) {
        case planEnum.BASIC:
          return this.$t('care.planName.basic');
        case planEnum.ADVANCE:
          return this.$t('care.planName.advanced');
        case planEnum.PREMIER:
          return this.$t('care.planName.premium');
        case planEnum.ELITE:
          return this.$t('care.planName.elite');
        case planEnum.BASIC_PRO:
          return this.$t('care.planName.basic2');
        case planEnum.ADVANCE_PRO:
          return this.$t('care.planName.advancedPro');
        case planEnum.PREMIUM_PRO:
          return this.$t('care.planName.premiumPro');
        case planEnum.ELITE_PRO:
          return this.$t('care.planName.elitePro');
        case planEnum.ULTRA_CARE:
          return this.$t('care.planName.ultraCare');
        case planEnum.ELITE_CARE:
          return this.$t('care.planName.eliteCare');
        default:
          return this.$t('care.planName.basic2');
      }
    },
  },
};
</script>
<style lang="sass" scoped>
.care-plan-card-wrapper
  --plan-name-font-size: 32px
  --content-text-font-size: 16px
  --img-icon-cvr-width: 36px
  width: 280px
  background-color: $background-primary
  border-radius: 20px
  position: relative
  .is-best-value
    position: absolute
    top: 0
    right: 0
    transform: translate(-40px, -100%)
    display: inline-block
    color: $main-text-content-color-light
    background-color: $lollipop-focus
    font-size: 16px
    line-height: 1.2
    font-weight: 400
    padding: 8px 12px
    border-radius: 10px 10px 0 0
  .is-web-only
    position: absolute
    top: 0
    right: 0
    transform: translate(-40px, -100%)
    display: inline-block
    color: $main-text-content-color-light
    background-color: $lollipop-focus
    font-size: 16px
    line-height: 1.2
    font-weight: 400
    padding: 8px 12px
    border-radius: 10px 10px 0 0
  .plan-card-container
    .block-plan-name-container
      display: flex
      justify-content: center
      align-items: center
      font-size: var(--plan-name-font-size)
      line-height: 1.2
      font-weight: 400
      padding: 20px 0
      .img-icon-24-cvr
        width: var(--img-icon-cvr-width)
        margin-right: 8px
    .divider
      width: 100%
      height: 2px
      background-color: $lollipop-blue
    .block-plan-price
      font-size: 24px
      line-height: 1.2
      font-weight: 400
      padding: 36px 0
      .non-free
        display: flex
        flex-direction: column
        .origin-price
          font-size: 16px
          color: $secondary
          text-decoration: line-through
        .discount-price
          color: $lollipop-focus
          margin-top: 8px
        .limited-offer-notice
          font-size: 12px
          color: $lollipop-focus
          margin-top: 8px
    .block-plan-detail-list
      padding: 0px 24px 20px
      text-align: left
      .plan-detail-item
        display: flex
        align-items: center
        margin-bottom: 18px
        .img-wrapper
          display: flex
          .img-icon
            width: 16px
            height: 14px
            margin: 4px 10px
            background-image: url('/media/img/icons/others/icon_selected.png')
            background-repeat: no-repeat
            background-size: contain
            &.inactive
              background-image: url('/media/img/icons/others/icon_unselected.png')
          .tag-new
            height: fit-content
            font-size: 14px
            font-weight: 900
            color: $main-text-content-color-light
            background-color: $lollipop-focus
            padding: 0 8px
            margin: 0 8px 0 0
            border-radius: 8px
            &.inactive
              background-color: #D3D3D3
        .text-desc
          font-size: var(--content-text-font-size)
          line-height: 1.4
          font-weight: 400
          span
            font-size: calc(var(--content-text-font-size) * 0.75)
            color: #808080
          &.inactive
            color: #d0d0d0
            span
              color: #d0d0d0

@media screen and (max-width: 414px)
  .care-plan-card-wrapper
    --plan-name-font-size: 24px
    --content-text-font-size: 16px

@media screen and (min-width: 960px) and (min-aspect-ratio: 3/5) and (max-aspect-ratio: 9/10)
  .care-plan-card-wrapper
    --plan-name-font-size: 36px
    --content-text-font-size: 18px

</style>
